/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { primaryColor } from "../../material-dashboard-pro-react.jsx";

const numberInputStyle = {
  mainInput: {
    width: "100%",
    "&> input": {
      textAlign: "right",
      backgroundColor: "rgba(100, 100, 100, 0.05)",
      // paddingTop: '32px'
    },
    "&:after": {
      borderColor: primaryColor[0],
    },
  },
};

export default numberInputStyle;
